export default [
  {
    path: "/shop/list",
    name: "ShopList",
    meta: {
      title: "智慧优选",
      keepAlive: false,
      auth: true,
      home: false,
      footer: true,
      header: true,
    },
    component: () => import("@views/shop/ShopList.vue"),
  },
  {
    path: "/shop/detail/:id",
    name: "ShopDetail",
    meta: {
      title: "商品详情",
      keepAlive: false,
      auth: true,
      home: false,
      footer: true,
      header: true,
    },
    component: () => import("@views/shop/ShopDetail.vue"),
  },
];